import { AuthProvider } from '@arcana/auth'
import { createContext, useContext, useEffect, useState } from 'react'

const appID = process.env.REACT_APP_ARCANA_APP_ID || 'xar_live_36a6e93363c5a5f15811e2bc6d49a85e3786ce85'

let auth = new AuthProvider(appID)

const ArcanaContext = createContext<any>(null)

export const ArcanaAuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [initialized, setInitialized] = useState(false)
  const [loggedIn, setLoggedIn] = useState(false)
  const [loading, setLoading] = useState(false)

  const initializeAuth = async () => {
    setLoading(true)
    try {
      await auth.init()
      setInitialized(true)
    } catch (e) {
      console.error(e)
      setInitialized(false)
    }
    setLoading(false)
  }

  //Social Login
  const login = async (socialType: 'google' | 'twitch' | 'twitter' | 'discord' | 'github') => {
    if (initialized) {
      setLoading(true)
      try {
        await auth.loginWithSocial(socialType)
        setLoggedIn(true)
      } catch (e: any) {
        console.error(e)
      }
      setLoading(false)
    }
  }

  //Email Link/ Passwordless login
  const loginWithLink = async (email: string) => {
    if (initialized) {
      setLoading(true)
      try {
        await auth.loginWithLink(email)
        setLoggedIn(true)
        setLoading(false)
      } catch (e) {
        console.error(e)
        setLoading(false)
      }
    }
  }

  //Getting user Accounts
  const getAccounts = async () => {
    if (initialized) {
      try {
        return await auth.provider.request({ method: 'eth_accounts' })
      } catch (e) {
        console.error(e)
      }
    }
  }

  //Logout
  const logout = async () => {
    if (initialized && loggedIn) {
      try {
        await auth.logout()
        setLoggedIn(false)
      } catch (e) {
        console.error(e)
      }
    }
  }

  useEffect(() => {
    const checkLogin = async () => {
      try {
        await auth.init()
        if (await auth.isLoggedIn()) {
          setLoggedIn(true)
        }
      } catch (e) {
        console.error(e)
      }
    }
    checkLogin()
  }, [])

  return (
    <ArcanaContext.Provider
      value={{
        initializeAuth,
        loggedIn,
        login,
        loginWithLink,
        getAccounts,
        logout,
        initialized,
        auth,
        loading,
      }}
    >
      {children}
    </ArcanaContext.Provider>
  )
}

export const useArcanaContext = () => useContext<IUseData>(ArcanaContext)

interface IUseData {
  initializeAuth: () => Promise<void>
  loggedIn: boolean
  login: (socialTypes: 'google' | 'twitch' | 'twitter' | 'discord' | 'github') => Promise<void>
  loginWithLink: (email: string) => Promise<void>
  getAccounts: () => Promise<unknown>
  logout: () => Promise<void>
  initialized: boolean
  auth: AuthProvider
  loading: boolean
}
